import { createApp } from "vue";
// Глобальные правила видимой области / клавиатуры. Подключаем ровно один раз,
// чтобы они не дублировались через scoped-импорты main.scss.
import "@/assets/style/viewport.scss";
import "@/assets/style/animations.scss";
import App from "./App.vue";
import { i18n } from "@/i18n";
import router from "./router";
import store, { key } from "@/store";
import AuthLayout from "@/layouts/AuthLayout.vue";
import MainLayout from "@/layouts/MainLayout.vue";
import PrimeVue from "primevue/config";
import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";

createApp(App)
  .component("MainLayout", MainLayout)
  .component("AuthLayout", AuthLayout)
  .use(store, key)
  .use(router)
  .use(i18n)
  .use(PrimeVue, {
    cssLayer: {
      name: "primevue",
      order: "app-styles, primevue, another-css-library",
    },
  })
  .mount("#app");

const firebaseConfig = {
  apiKey: "AIzaSyCYWbJ-WMenEB49Vq44S3gUCtKtWZ1i4J4",
  authDomain: "moi-operator.firebaseapp.com",
  projectId: "moi-operator",
  storageBucket: "moi-operator.firebasestorage.app",
  messagingSenderId: "274484938608",
  appId: "1:274484938608:web:e1b6cc2bdab5e1e01371b5",
  measurementId: "G-W10XL4K6Z3",
};

if ("serviceWorker" in navigator) {
  window.addEventListener("load", async () => {
    try {
      // Register Firebase messaging SW
      await navigator.serviceWorker.register("/firebase-messaging-sw.js");

      console.log("Firebase Messaging SW registered");
    } catch (err) {
      console.error("SW registration failed:", err);
    }
  });
}

const fcmToken =
  "BMwNeXyZVGhv1RS4hZn80Au-Geig87LoyOTArowd4jYyHHBFF-5dNq--NoDq5JqHrfrWEmxUyxJUVtHKqcMOwSs";

const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);

await Notification.requestPermission()
  .then(async (res) => {
    console.log(res);
    const token = await getToken(messaging, {
      vapidKey: fcmToken,
    });

    console.log("FCM TOKEN:", token);
  })
  .catch((err) => {
    console.log(err);
  });
